import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';

import { getResourceTo } from 'react/utils/utils';

import CloseChat from 'static/images/chat/close.svg';
import ChatUsersList from 'react/containers/layout/Bottom/chatUsersList';
import ChatOrganizationsList from 'react/containers/layout/Bottom/chatOrganizationsList';

function SuspenseActionsTabs({
  suspenseActionsIsOpen,
  toggleSuspenseActions
}) {
  return (
    <div 
      data-testid="suspense-actions-hub"
      className={!suspenseActionsIsOpen ? 'suspenseChatActions closed' : 'suspenseChatActions open'}
    >
      {suspenseActionsIsOpen && (
        <div className="suspense-container">
          <div className="suspense-header">
            <h4>Chat</h4>
            <img src={CloseChat} alt="Close chat Icon" onClick={toggleSuspenseActions} />
          </div>
          <div className="suspense-content">
            <Tabs>
              <TabList>
                <Tab>
                  {getResourceTo('suspenseActions.usersTab.title')}
                </Tab>
                <Tab>
                  {getResourceTo('suspenseActions.organizationsTab.title')}
                </Tab>
              </TabList>
              <TabPanel className="users-list">
                <ChatUsersList />
              </TabPanel>
              <TabPanel className="organizations-list">
                <ChatOrganizationsList />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      )}
    </div>
  );
}

SuspenseActionsTabs.propTypes = {
  suspenseActionsIsOpen: PropTypes.bool.isRequired,
  toggleSuspenseActions: PropTypes.func.isRequired
};

export default SuspenseActionsTabs;